import { call } from '@advanza/api'
import { formatPriceWithCurrency } from '@advanza/func'
import { Divider } from '@advanza/ui'
import Card from 'components/Card'
import { useEffect, useState } from 'react'

const UpcomingInvoiceCard = ({ provider }: { provider: any }) => {
    const [data, setData] = useState<
        | {
              amount_of_all_charges_except_reclaims: number
              amount_of_all_reclaims: number
              total_amount_debited: number
              amount_of_presence_subscription_charges: number
              amount_of_lead_charges_except_reclaims: number
              amount_of_upcoming_presence_fees: number
              amount_of_upcoming_presence_discounts: number
              net_presence_fee: number
          }
        | undefined
    >()
    useEffect(() => {
        call(`office/providers/get-upcoming-invoice-info/${provider.service_provider_id}`).then(
            (response) => {
                setData(response.data)
            },
        )
    }, [])

    if (!data) {
        return null
    }

    const isNotSignedAndHasNoUpcomingInvoice =
        !provider.isSigned &&
        !data.amount_of_all_reclaims &&
        !data.amount_of_lead_charges_except_reclaims &&
        !data.amount_of_presence_subscription_charges &&
        !data.net_presence_fee &&
        !data.total_amount_debited

    if (isNotSignedAndHasNoUpcomingInvoice) {
        return null
    }

    return (
        <Card header="Upcoming invoice">
            <div>
                Total received requests:{' '}
                {formatPriceWithCurrency(data.amount_of_lead_charges_except_reclaims)}
            </div>
            <Divider s />
            <div>
                Premium Contribution:{' '}
                {formatPriceWithCurrency(
                    data.amount_of_presence_subscription_charges + data.net_presence_fee,
                )}
            </div>
            <Divider s />
            <div>
                Deduction accepted reclaims: {formatPriceWithCurrency(data.amount_of_all_reclaims)}
            </div>
            <Divider s />
            <div>
                Total amount next invoice (excl. VAT):{' '}
                {formatPriceWithCurrency(data.total_amount_debited)}
            </div>
        </Card>
    )
}

export default UpcomingInvoiceCard
